import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
const pad = (i: number): string => i < 10 ? `0${i}` : `${i}`;
 /**
  * This handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
  */
  @Injectable()
  export class CustomDateParserFormatter extends NgbDateParserFormatter {
    readonly DELIMITER = '-';
    parse(value: string): NgbDateStruct | null {
      if (value) {
        const date = value.split(this.DELIMITER);
        return {
          day : parseInt(date[2], 10),
          month : parseInt(date[1], 10),
          year : parseInt(date[0], 10)
        };
      }
      return null;
    }
    format(date: NgbDateStruct | null): string {
      return date ? `${pad(date.year)}${this.DELIMITER}${pad(date.month)}${this.DELIMITER}${pad(date.day)}` : '';
    }
  }